import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { otpSchema } from '@utils/validationSchemas'

const OTPStep = ({
    email,
    otp,
    isVerifying,
    error,
    otpExpiry,
    timeLeft,
    canResend,
    onOtpChange,
    onKeyDown,
    onPaste,
    onSubmit,
    onResend,
    onBackToEmail,
}) => {
    const {
        handleSubmit,
        formState: { errors },
        setValue,
        clearErrors,
    } = useForm({
        resolver: yupResolver(otpSchema),
        defaultValues: {
            otp: '',
        },
    })

    // Update form value when OTP array changes
    useEffect(() => {
        const otpString = otp.join('')
        setValue('otp', otpString)
        if (otpString.length === 6) {
            clearErrors('otp')
        }
    }, [otp, setValue, clearErrors])

    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60)
        const secs = seconds % 60
        return `${mins}:${secs.toString().padStart(2, '0')}`
    }

    return (
        <>
            <div className="employee-login-otp-header">
                <h2>Verify Your Email</h2>
                <p>We've sent a 6-digit code to</p>
                <p className="employee-login-verification-target">{email}</p>
            </div>

            {error && (
                <div className="employee-login-alert employee-login-alert-danger">
                    <i className="bx bx-error-circle"></i>
                    {error}
                </div>
            )}

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="employee-login-otp-inputs">
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            id={`otp-${index}`}
                            type="text"
                            inputMode="numeric"
                            maxLength="1"
                            value={digit}
                            onChange={e => onOtpChange(index, e.target.value)}
                            onKeyDown={e => onKeyDown(index, e)}
                            onPaste={onPaste}
                            className={errors.otp ? 'employee-login-otp-error' : ''}
                        />
                    ))}
                </div>

                {errors.otp && (
                    <div className="employee-login-alert employee-login-alert-danger employee-login-alert-center">
                        {errors.otp.message}
                    </div>
                )}

                <button type="submit" disabled={isVerifying || otp.join('').length !== 6} className="employee-login-btn-verify">
                    {isVerifying ? 'Verifying...' : 'Verify Code'}
                </button>
            </form>

            <div className="employee-login-resend-section">
                {!canResend ?
                    <p className="employee-login-countdown">Resend code in {formatTime(timeLeft)}</p>
                :   <button onClick={onResend} className="employee-login-resend-btn">
                        Resend code
                    </button>
                }
            </div>

            <div className="employee-login-back-link">
                <button onClick={onBackToEmail} className="employee-login-back-btn">
                    ← Change Email Address
                </button>
            </div>
        </>
    )
}

export default OTPStep
